import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

const NoCertificationIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 49 41" {...props}>
      <path
        d="M23.7275 10.5005C26.9101 10.5005 29.9624 11.7648 32.2128 14.0152C34.4633 16.2657 35.7275 19.3179 35.7275 22.5005C35.7275 25.6831 34.4633 28.7354 32.2128 30.9858C29.9624 33.2362 26.9101 34.5005 23.7275 34.5005C20.5449 34.5005 17.4927 33.2362 15.2423 30.9858C12.9918 28.7354 11.7275 25.6831 11.7275 22.5005C11.7275 19.3179 12.9918 16.2657 15.2423 14.0152C17.4927 11.7648 20.5449 10.5005 23.7275 10.5005ZM23.7275 15.7505L21.743 19.7705L17.3075 20.4155L20.5175 23.543L19.76 27.962L23.7275 25.8755L27.695 27.9605L26.9375 23.543L30.1475 20.414L25.712 19.769L23.7275 15.7505ZM25.2275 2.99902L32.7275 3.00052V7.50052L30.683 9.20752C28.9865 8.3174 27.1341 7.76277 25.2275 7.57402V3.00052V2.99902ZM22.2275 2.99902V7.57402C20.3216 7.76249 18.4698 8.3166 16.7735 9.20602L14.7275 7.50052V3.00052L22.2275 2.99902Z"
        fill="#C0C5CD"
      />
      <path d="M2 37.1018L47 3" stroke={colors.light} strokeWidth="3.32553" />
      <path d="M2 39.6292L47 5.52734" stroke="#C0C5CD" strokeWidth="3.32553" />
    </SvgIcon>
  );
};

export default NoCertificationIcon;
